import React, { useContext, useMemo } from "react";
import { PurchaseValidationContext } from "./PurchaseValidationContext";
import { ActionCard } from "../common/ActionCard";
import MixpanelService from "../utils/MixpanelService";

export const ActionCards = () => {
  const {
    accounts,
    setSubmitClaimsModal,
    unassignedIdentifierCount,
    coveredEntity340bId,
    identifierMappingPath,
  } = useContext(PurchaseValidationContext);

  const invalidAccountCount = useMemo(
    () =>
      accounts.filter((account) => ["at_risk", "suspended"].includes(account.display_status))
        .length,
    [accounts]
  );

  return (
    <div className="container-fluid">
      <div className="row gap--24">
        <ActionCard
          title="At Risk and Suspended Accounts"
          count={invalidAccountCount}
          description="Accounts are considered At Risk or Suspended when there are insufficient claims to support the covered entity purchases. To rectify, submit claims for your entity."
          buttonText="Submit Claims"
          onButtonClick={() => {
            MixpanelService.track("esp_horizon_submit_claims_started");
            setSubmitClaimsModal(true);
          }}
        />
        <ActionCard
          title="Unassigned Identifiers for Review"
          count={unassignedIdentifierCount}
          description="An identifier is considered unassigned when it is not mapped to a covered entity account. This could contribute to an increased risk of At Risk and Suspended accounts. Manage identifiers by reviewing and mapping."
          buttonText="Manage Identifiers"
          onButtonClick={() => {
            MixpanelService.track("esp_horizon_manage_identifiers");
            window.location.href = `${identifierMappingPath}?id_340b=${coveredEntity340bId}`;
          }}
        />
      </div>
    </div>
  );
};
